import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { TenantRefService } from 'app/shared/services/tenant-ref.service';
import { environment } from 'environments/environment';
import { Observable, catchError, throwError } from 'rxjs';

export const authInterceptor = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const authService = inject(AuthService);
    const tenantRefService = inject(TenantRefService);
    let newReq = req.clone();

    if (newReq.url.startsWith('api/')) {
        newReq = newReq.clone({
            url: `${environment.apiOrigin}/${newReq.url}`,
            withCredentials: true,
            // Service Worker bypass for all API requests
            setHeaders: {
                'ngsw-bypass': 'true'
            }
        });
    }
    return next(newReq).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                authService.handleUnauthorized401(error.error);
            }
            if (error instanceof HttpErrorResponse && error.status === 403) {
                tenantRefService.redirectIfTenantMismatch(error.error);
            }
            return throwError(() => error);
        })
    );
};
